import { articleCreationSchema, jArticleListSchema, jArticleLittleSchema, jArticleViewSchema } from './article';
import { licenseSchema } from './adminLicense';
import { z } from 'zod';

export const jLandLogSchema = z.object({
    idLog: z.number(),
    slug: z.string(),
    dateCreation: z.string(),
    map: z.string(),
    mail: z.string(),
    action: z.string(),
    mode: z.string(),
});
export type JLandLog = z.infer<typeof jLandLogSchema>;

export const jLandStatSchema = z.object({
    mail: z.string(),
    cnt: z.string(),
});
export type JLandStat = z.infer<typeof jLandStatSchema>;

export const jLandMapFlavorSchema = z.string();
export type JLandMapFlavor = z.infer<typeof jLandMapFlavorSchema>;

export const jLandMapKindSchema = z.string();
export type JLandMapKind = z.infer<typeof jLandMapKindSchema>;

export const jLandMapSchema = jArticleLittleSchema.extend({
    jlandMapFlavor: jLandMapFlavorSchema,
    jlandMapKind: jLandMapKindSchema,
    waMapUrl: z.string().optional(),
    limit: z.number().optional(),
    _extend: z.object({
        licenses: z.array(licenseSchema),
    }),
});
export type JLandMap = z.infer<typeof jLandMapSchema>;

export const JLandMapCreationSchema = articleCreationSchema.extend({
    jlandMapAggregated: z.string(),
    type: z.literal('jlandmap'),
});
export type JLandMapCreation = z.infer<typeof JLandMapCreationSchema>;

export const jLandAdditionalPropsSchema = z.object({
    jlandMapKind: z.string(),
    jlandMapFlavor: z.string(),
    limit: z.number().nullable(),
    waMapUrl: z.string().nullable(),
});

export const jLandMapLittleSchema = jArticleLittleSchema.and(jLandAdditionalPropsSchema);
export type JLandMapLittle = z.infer<typeof jLandMapLittleSchema>;

export const jLandMapListSchema = jArticleListSchema.and(jLandAdditionalPropsSchema);
export type JLandMapList = z.infer<typeof jLandMapListSchema>;

export const jLandMapViewSchema = jArticleViewSchema.and(jLandAdditionalPropsSchema);
export type JLandMapView = z.infer<typeof jLandMapViewSchema>;
